import { axiosApiService as axios } from '../axios';

const BASE_URL = 'user/settings/';

const UserSettingsAPI = {
  getSettings: async () => {
    try {
      const response = await axios.get(BASE_URL);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateSettings: async (data) => {
    try {
      const response = await axios.patch(BASE_URL, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

};

export default UserSettingsAPI;
